import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Contact } from "@/components/landing/Contact";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Home() {
  const [visits, setVisits] = useState(null);

  useEffect(() => {
    axios.post(`${API}/visits`).then((res) => setVisits(res.data.count)).catch(() => {});
  }, []);

  return (
    <div data-testid="home-page" className="max-w-xl mx-auto px-6 py-12">
      <header data-testid="hero-section">
        <h1 className="font-bold text-3xl">WanCo Industries</h1>
        <p className="font-mono90 text-sm mt-1">* mobile application developer *</p>
        <p className="font-mono90 text-sm mt-2">
          [ <Link data-testid="nav-about-link" to="/about">about</Link> ] [ <Link data-testid="nav-apps-link" to="/apps">apps</Link> ] [ <a data-testid="nav-contact-link" href="#contact">contact</a> ]
        </p>
      </header>

      <hr className="hr90" />

      <section data-testid="intro-section">
        <p className="text-lg leading-relaxed">
          Welcome to our homepage. We are WanCo. We make apps for phones.
          iOS and Android. That's it, really.
        </p>
        <p className="text-lg leading-relaxed mt-4">
          Got an idea for an app? Drop us a line below.
        </p>
      </section>

      <hr className="hr90" />

      <Contact />

      <hr className="hr90" />

      <footer data-testid="footer-section" className="font-mono90 text-xs">
        <p>&copy; 2026 WanCo Industries &middot; <a data-testid="footer-email-link" href="mailto:wanwan@wanco.space">wanwan@wanco.space</a></p>
        <p className="mt-2">Best viewed in any browser at any resolution.</p>
        <p className="mt-2" data-testid="visitor-counter">
          You are visitor no. {visits === null ? "......" : String(visits).padStart(6, "0")}
        </p>
      </footer>
    </div>
  );
}
